<template>
  <div class="product-detail">
    <div class="modal-background">
      <div class="modal-wrapper" :class="$mq">
        <div class="modal" :class="{TA:isTestAchat}">
          <h1>
            <SvgIcon
              class="icon"
              :icon="`product-${productName}`"
              fill
            ></SvgIcon>
            {{ productName | capitalize }}
            <span class="close" @click="$emit('close')"></span>
          </h1>
          <div class="price">
            <div class="inline center" v-if="!annualPriceByRange.includes(productName)">
              <span class="bold">{{ priceByFrequency | formatPrice }}</span>
              <span class="unit">€ {{ priceLabel }} /{{ $tc(`Offer.Product.${this.products[0].paymentFrequencies[0]}`) }}</span>
            </div>
            <div class="inline center">
              <span :class="{bold: annualPriceByRange.includes(productName)}">{{ price.annual | formatPrice }}</span>
              <span class="unit">€ {{ priceLabel }} /{{$tc('Offer.Product.year')}}</span>
            </div>
          </div>
          <div v-for="product in products" :key="product.id" class="details">
            <h2 class="product">
              <SvgIcon :icon="product.energyType"></SvgIcon>
              {{ product.descriptions[$i18n.locale] }}
            </h2>
            <table class="price-detail">
              <tr>
                <th></th>
                <th>c€/kWh</th>
                <th>€/{{ $tc('Offer.Product.year')}} </th>

              </tr>
              <tr>
                <td>{{ $t('Offer.Product.Detail.pricing.subscription') }}</td>
                <td></td>
                <td>{{ product.subscription[priceType] | formatPrice}}</td>
              </tr>
              <tr v-if="product.subtotal.discount">
                <td>
                    {{ $t('Offer.Product.Detail.pricing.discount') }}
                    <span class="required">
                        {{ product.range === 'COSY' ? '**' : product.range === 'SMART' ? '*' : ''}}
                    </span>
                </td>
                <td></td>
                <td>{{ product.subtotal.discount[priceType] | formatPrice}}</td>
              </tr>
              <tr v-for="(energy, energyName) in product.energy" :key="energyName">
                <td>{{ getEnergyLabel(product.energyType, energyName, product.energy) }}</td>
                <td>{{ energy[unitaryPriceType] * 100 | formatPrice }}</td>
                <td>{{ energy[priceType] | formatPrice }}</td>
              </tr>
              <tr v-if="wantGreen && product.energyType === 'gas'">
                <td>{{ $t('Offer.Product.Detail.pricing.green') }}</td>
                <td></td>
                <td>{{ product.subtotal.energy[priceEcoType] - product.subtotal.energy[priceType] | formatPrice }}</td>
              </tr>
              <tr v-if=" product.subtotal.renewable !== undefined">
                <td>{{ $t("Offer.Product.Detail.pricing.ecotaxes") }}</td>
                <td>{{ product.subtotal.renewable[unitaryPriceType] * 100 | formatPrice }}</td>
                <td>{{ product.subtotal.renewable[priceType] | formatPrice }}</td>
              </tr>
              <tr v-if="product.subtotal.prosumer !== undefined">
                <td>{{ $t('Offer.Product.Detail.pricing.prosumer') }}</td>
                <td></td>
                <td>{{ product.subtotal.prosumer[priceType] | formatPrice }}</td>
              </tr>
              <tr v-if="product.subtotal.forfaitPv !== undefined">
                <td>{{ $t('Offer.Product.Detail.pricing.forfaitPv') }}</td>
                <td></td>
                <td>{{ product.subtotal.forfaitPv[priceType] | formatPrice }}</td>
              </tr>
              <tr>
                <td>{{ $t('Offer.Product.Detail.pricing.taxes') }}</td>
                <td></td>
                <td>
                    {{ (product.subtotal.taxesVAT ? product.subtotal.taxesVAT[priceType] : 0) +
                       (product.subtotal.taxes ? product.subtotal.taxes[priceType] : 0) +
                       (product.subtotal.transportAndDistribution ? product.subtotal.transportAndDistribution[priceType] : 0)
                    | formatPrice}}
                </td>
              </tr>
              <tr class="total">
                <td>Total</td>
                <td></td>
                <td>{{ product.total[priceType] | formatPrice }}</td>
              </tr>
            </table>
            <p></p>
          </div>
        </div>
        <button class="button main" @click="$emit('close')">{{ $t('back') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import capitalize from "@/mixins/capitalize";
import enums from "@/enums";


export default {
  mixins: [capitalize],
  props: {
    range: {
      type: Object,
    },
  },
  data() {
    return {
      annualPriceByRange: [enums.productEnum.PREPAID]
    }
  },
  computed: {
    ...mapState("contact", ["isPro"]),
    ...mapState("consumption", ["solarPanelsScenario"]),
    ...mapGetters("common", ["isTestAchat"]),
    productName() {
      let product = this.range.electricity || this.range.gas;

      return product.labels.name;
    },
    type() {
      return this.$store.state.subscription.customerType;
    },
    unitaryPriceType() {
      return !this.isPro ? 'unitaryPriceEuroVAT' : 'unitaryPriceEuro';
    },
    priceType() {
      return !this.isPro ? 'priceEuroVAT' : 'priceEuro';
    },
    priceEcoType() {
      return !this.isPro ? 'priceEuroVATEco' : 'priceEuroEco';
    },
    wantGreen() {
      return this.$store.state.simulation.wantGreen;
    },
    priceLabel() {
      return this.isPro ? this.$t('Offer.Product.ht') : this.$t('Offer.Product.ttc');
    },
    products() {
      return this.$store.getters["simulation/selectedProducts"](this.range);
    },
    price() {
      let products = this.products;
      let price = null;

      if(products[0].total) {
        price = {};

        if (this.isPro) {
          price.annual = products.reduce((x, y) => {
            if(this.wantGreen && y.total.priceEuroEco !== undefined) return x + y.total.priceEuroEco
            else return x + y.total.priceEuro;
          }, 0);
          price.monthly = products.reduce((x, y) => {
            if(this.wantGreen && y.total.priceEuroMonthlyEco !== undefined) return x + y.total.priceEuroMonthlyEco
            else return x + y.total.priceEuroMonthly;
          }, 0);
        } else {
          price.annual = products.reduce((x, y) => {
            if(this.wantGreen && y.total.priceEuroVATEco !== undefined) return x + y.total.priceEuroVATEco
            else return x + y.total.priceEuroVAT;
          }, 0);
          price.monthly = products.reduce((x, y) => {
            if(this.wantGreen && y.total.priceEuroMonthlyVATEco !== undefined) return x + y.total.priceEuroMonthlyVATEco
            else return x + y.total.priceEuroMonthlyVAT;
          }, 0);
        }
      }

      return price;
    },
    priceByFrequency() {
      let frequency = {
        monthly: 1,
        quarterly: 3
      }

      let multiply = frequency[this.products[0].paymentFrequencies[0]] | 1

      return this.price.monthly * multiply
    }
  },
  methods: {
    isDual: function (meters) {
      return meters.filter(function (meter){
        return !meter.includes('injection');
      }).length;
    },
    getEnergyLabel(energy, energyName, list){
      if(energy === 'gas'){
        return this.$tc(`Offer.Product.Detail.pricing.gas`)
      }
      // if(this.solarPanelsScenario !== 'COMM_OFFTAKE_AND_INJECTION'){
      //   return this.$tc(`Offer.Product.Detail.pricing.${energyName}`, this.isDual(Object.keys(list)))
      // }
      // return this.$tc(`Offer.Product.Detail.pricing.${energyName}Net`, this.isDual(Object.keys(list)))
      return this.$tc(`Offer.Product.Detail.pricing.${energyName}`, this.isDual(Object.keys(list)));
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  justify-content: center;
  align-items: center;
  background: $yellow;
  text-align: center !important;
  font-size: 1.5rem !important;
  display: block;
  max-height: 80px;
  padding: 0;

  .icon {
      font-size: 2rem;
      display: flex;
      padding-top: 8px;
      flex-direction: row;
      align-items: flex-start;
      justify-content: center;
      max-height: 50px;
      margin-bottom: 4px; //for safari
  }
}

.price {
  // background: $clearYellow;
  padding: 10px 0;

  div {
    margin-bottom: 5px;
  }

  .unit {
    display: block;
    font-size: 0.5rem;
    width: 45px;
  }

  .bold {
    font-weight: bold;
  }
}

.details {
  // background: $clearYellow;

  .product {
    margin: 0!important;
    padding: 5px;
    font-size: 0.9rem!important;
    display: flex!important;
    justify-content: center;
    background: $clearYellow;
  }

  .price-detail {
    width: 100%;
    font-size: 0.8rem;
    background: $white;
    border-collapse: collapse;

    th {
      font-weight: 600;
      padding: 5px 0;
    }

    tr:nth-child(even) {
        background: $lightGrey;
    }

    .total {
      font-weight: 600;
      background: rgb(228, 228, 228);
    }

    td {
      padding: 5px 0;
    }
  }
}

.modal {
  &.TA {
    h1 {
      background: $orange!important
    }

    .product {
      background-color: $orange;
      color: $white;

      /deep/ svg {
        fill: $white;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/simulation/Detail.vue